var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockSolid = function SvgClockSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m-.75 3.75V8c0 .25.125.484.334.625l3 2a.75.75 0 0 0 1.041-.21.747.747 0 0 0-.21-1.04L8.75 7.6V3.75A.75.75 0 0 0 8 3a.75.75 0 0 0-.75.75"
  })));
};
export default SvgClockSolid;